import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=46bbf666&scoped=true"
import script from "./Place.vue?vue&type=script&lang=js"
export * from "./Place.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bbf666",
  null
  
)

export default component.exports